module.exports = __webpack_public_path__ + "static/img/food-3.9dc0b85.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/food-3.png
// module id = RX2O
// module chunks = 1